import { defineStore } from 'pinia'
import { STORE_ID } from '~/constants/store'
import type { StripePaymentSheetResult, StripePaymentSheetState } from '~/types/stripe'

const initialState = (): StripePaymentSheetState => ({
  pendingResult: null
})

const useStripePaymentSheetStore = defineStore(STORE_ID.STRIPE_PAYMENT_SHEET, {
  state: initialState,
  actions: {
    publishResult(result: StripePaymentSheetResult) {
      this.pendingResult = result
    },
    consumeResult(): StripePaymentSheetResult | null {
      const result = this.pendingResult
      this.pendingResult = null
      return result
    }
  }
})

export default useStripePaymentSheetStore
export { initialState }
